export default __webpack_public_path__ + "static/media/branding-box-image-03.0d460b8c.png";